import styled, { css } from "styled-components";
import { colorBrandBase, colorBrandDark, colorBlack, colorWhite } from "@nib-components/theme";
import { mixins, variables } from "@nib-group/chatbot-shared/styles";
// ----------------------------------------
// Local variables
const TOOLBAR_HEIGHT = "35px";
// ----------------------------------------
// Exports
export const Wrapper = styled.div`
  display: flex;
  justify-content: space-between;
  position: relative;
  border-top-left-radius: ${variables.BORDER_RADIUS};
  border-top-right-radius: ${variables.BORDER_RADIUS};
  background: ${colorBrandBase};
  width: 100%;
  min-height: ${TOOLBAR_HEIGHT};
`;
export const UnseenMessageBadge = styled.div`
  ${mixins.circle(TOOLBAR_HEIGHT)}
  position: absolute;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: ${variables.BOX_SHADOW};
  background-color: ${variables.UNREAD_NOTIFICATION_COLOR};
  color: ${colorWhite};
  text-shadow: 1px 1px ${colorBlack};
  top: -${parseInt(TOOLBAR_HEIGHT) / 2}px;
  left: -${parseInt(TOOLBAR_HEIGHT) / 2}px;
  font-weight: 700;
  font-size: 16px;
  z-index: 2;
`;
export const StatusContainer = styled.div`
  padding-left: 15px;
  display: flex;
  align-items: center;
  color: ${colorWhite};
  z-index: 1;
  font-size: 14px;
`;
export const FlipIcon = styled.div`
  ${mixins.accessibleTransition("transform")}
  transform: rotate(0);

  ${_ref => {
  let {
    shouldFlip
  } = _ref;
  return shouldFlip && css`
      transform: rotate(180deg);
    `;
}}
`;
export const ButtonContainer = styled.div`
  border-top-right-radius: ${variables.BORDER_RADIUS};
  display: flex;
  overflow: hidden;
`;
export const ToolbarButton = styled.button`
  ${mixins.buttonReset}
  ${mixins.square(TOOLBAR_HEIGHT)};
  ${mixins.accessibleTransition("background")}
  position: relative;
  color: ${colorWhite};

  &:hover,
  &:focus-visible {
    background: ${colorBrandDark};
  }

  svg {
    ${mixins.accessibleTransition("transform")}
    ${mixins.alignCentre}
  }
`;